const services = [
  {
    type: "BE",
    name: "Content",
    git: "https://github.com/Akelius-Languages-Online/university-content-service/commit/",
    swagger: "/swagger-ui/index.html",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/content",
    testing:
      "https://business-school-testing.development.languages.akelius.com/content",
    production:
      "https://business-school.production.languages.akelius.com/content",
  },
  {
    type: "BE",
    name: "Authorization",
    git: "https://github.com/Akelius-Languages-Online/university-authorization-service/commit/",
    swagger: "/swagger-ui/index.html",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/authorization",
    testing:
      "https://business-school-testing.development.languages.akelius.com/authorization",
    production:
      "https://business-school.production.languages.akelius.com/authorization",
  },
  {
    type: "BE",
    name: "Root",
    git: "https://github.com/Akelius-Languages-Online/university-root-service/commit/",
    swagger: "/swagger-ui.html",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/root",
    testing:
      "https://business-school-testing.development.languages.akelius.com/root",
    production: "https://business-school.production.languages.akelius.com/root",
  },
  {
    type: "BE",
    name: "User",
    git: "https://github.com/Akelius-Languages-Online/university-user-service/commit/",
    swagger: "/swagger-ui/index.html",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/user",
    testing:
      "https://business-school-testing.development.languages.akelius.com/user",
    production: "https://business-school.production.languages.akelius.com/user",
  },
  {
    type: "BE",
    name: "LRS - Proxy",
    git: "https://github.com/Akelius-Languages-Online/university-lrs-proxy/commit/",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/lrsproxy",
    testing:
      "https://business-school-testing.development.languages.akelius.com/lrsproxy",
    production:
      "https://business-school.production.languages.akelius.com/lrsproxy",
  },
  {
    type: "BE",
    name: "Statistics",
    git: "https://github.com/Akelius-Languages-Online/university-statistic-service/commit/",
    swagger: "/swagger-ui/index.html",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/statistics",
    testing:
      "https://business-school-testing.development.languages.akelius.com/statistics",
    production:
      "https://business-school.production.languages.akelius.com/statistics",
  },
  {
    type: "BE",
    name: "Lock-service",
    git: "https://github.com/Akelius-Languages-Online/university-lock-service/commit/",
    swagger: "/swagger-ui/index.html",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/lock",
    testing:
      "https://business-school-testing.development.languages.akelius.com/lock",
    production: "https://business-school.production.languages.akelius.com/lock",
  },
  {
    type: "BE",
    name: "GDPR-compliance-service",
    git: "https://github.com/Akelius-Languages-Online/university-gdpr-compliance-service/commit/",
    swagger: "/graphiql",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/gdpr",
    testing:
      "https://business-school-testing.development.languages.akelius.com/gdpr",
    production: "https://business-school.production.languages.akelius.com/gdpr",
  },
  {
    type: "BE",
    name: "Media",
    git: "https://github.com/Akelius-Languages-Online/generator-media-service/commit/",
    swagger: "/swagger-ui/index.html",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/media",
    testing:
      "https://business-school-testing.development.languages.akelius.com/media",
    production:
      "https://business-school.production.languages.akelius.com/media",
  },
  {
    type: "BE",
    name: "Keyboard Service",
    git: "https://github.com/Akelius-Languages-Online/university-keyboard-app/commit/",
    development:
      "https://university-keyboard-app.development.languages.akelius.com/keyboard",
    testing: "",
    production:
      "https://university-keyboard-app.production.languages.akelius.com/keyboard",
  },
  {
    type: "BE",
    name: "Secret Code Service",
    git: "https://github.com/Akelius-Languages-Online/university-secret-code-service/commit/",
    swagger: "/swagger-ui/index.html",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/secret-code",
    testing:
      "https://business-school-testing.development.languages.akelius.com/secret-code",
    production:
      "https://business-school.production.languages.akelius.com/secret-code",
  },
  {
    type: "BE",
    name: "LLM Service",
    git: "https://github.com/Akelius-Languages-Online/llm-service/commit/",
    swagger: "/swagger-ui/index.html",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/llm",
    production: "https://business-school.production.languages.akelius.com/llm",
  },
  {
    type: "BE",
    name: "Dictionary Service",
    git: "https://github.com/Akelius-Languages-Online/dictionary-service-backend/commit/",
    swagger: "/swagger-ui/index.html",
    info: "/actuator/info",
    development:
      "https://business-school-development.development.languages.akelius.com/dictionary",
    testing:
      "https://business-school-testing.development.languages.akelius.com/dictionary",
    production:
      "https://business-school.production.languages.akelius.com/dictionary",
  },
  {
    type: "FE",
    name: "Education hub",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/platforms-education-hub/commit/",
    info: "/git-info.json",
    report:
      "https://business-school-platform-end2end.development.languages.akelius.com",
    development: "https://hub.dev.akelius.education",
    testing: "https://education-hub-testing.development.languages.akelius.com",
    production: "https://akelius.education",
  },
  {
    type: "FE",
    name: "Platform Languages",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/university-platform-frontend/commit/",
    info: "/git-info.json",
    report:
      "https://business-school-platform-end2end.development.languages.akelius.com",
    development: "https://hub.dev.akelius.education/languages",
    testing:
      "https://business-school-testing.development.languages.akelius.com",
    production: "https://akelius.education/languages",
  },
  {
    type: "FE",
    name: "Platform Teachers",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/university-platform-frontend/commit/",
    info: "/git-info.json",
    report:
      "https://business-school-platform-end2end.development.languages.akelius.com",
    development:
      "https://teachers-development.development.languages.akelius.com",
    testing: "https://teachers-testing.development.languages.akelius.com",
    production: "https://teachers.akelius.education",
  },
  {
    type: "FE",
    name: "Math Platform",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/math-platform/commit/",
    info: "/git-info.json",
    report:
      "https://akelius-education-website-development.development.languages.akelius.com",
    development: "https://hub.dev.akelius.education/math",
    testing: "https://math-platform-testing.development.languages.akelius.com",
    production: "https://akelius.education/math",
  },
  {
    type: "FE",
    name: "Vocational Platform",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/vocational-platform/commit/",
    info: "/git-info.json",
    report: "https://vocational-platform.dev.akelius.education",
    development: "https://hub.dev.akelius.education/vocational/",
    testing: "https://vocational-platform.test.akelius.education/vocational/",
    production: "https://akelius.education/vocational/",
  },
  {
    type: "FE",
    name: "Teacher Training Platform",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/teacher-training-platform/commit/",
    info: "/git-info.json",
    development:
      "https://teacher-training-platform-development.development.languages.akelius.com/",
    testing:
      "https://teacher-training-platform-testing.development.languages.akelius.com",
    production: "https://teacher-training.akelius.education",
  },
  {
    type: "FE",
    name: "Dictionary",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/dictionary-service-frontend/commit/",
    info: "/git-info.json",
    development:
      "https://dictionary-development.development.languages.akelius.com",
    testing: "https://dictionary-development.development.languages.akelius.com",
    production: "https://dictionary.languages.akelius.education",
  },
  {
    type: "FE",
    name: "Generator (Asset App)",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/university-asset-app/commit/",
    info: "/git-info.json",
    report:
      "https://business-school-generator-e2e.development.languages.akelius.com",
    development:
      "https://business-school-asset-app-development.development.languages.akelius.com",
    testing:
      "https://business-school-asset-app-testing.development.languages.akelius.com",
    production:
      "https://business-school-asset-app.production.languages.akelius.com",
  },
  {
    type: "FE",
    name: "Consumer-Kit library",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/university-consumer-kit/commit/",
    info: "/git-info.json",
    development:
      "https://business-school-gen-consumer-dev.development.languages.akelius.com",
  },
  {
    type: "FE",
    name: "Chatbot",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/chatbot-frontend/commit/",
    info: "/git-info.json",
    development:
      "https://chatbot-frontend-kit-development.development.languages.akelius.com",
    production:
      "https://chatbot-frontend-kit-production.production.languages.akelius.com",
  },
  {
    type: "FE",
    name: "Classroom-Kit",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/classroom-kit/commit/",
    info: "/git-info.json",
    development:
      "https://classroom-frontend-development.development.languages.akelius.education",
  },
  {
    type: "FE",
    name: "Speed Math",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/speed-math/commit/",
    info: "/git-info.json",
    development: "https://speed-math.development.languages.akelius.com",
  },
  {
    type: "FE",
    name: "Prototypes",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/prototypes-frontend/commit/",
    info: "/git-info.json",
    development: "https://prototypes.dev.akelius.education/",
  },
  {
    type: "SP",
    name: "Keycloak",
    link: true,
    development:
      "https://business-school-keycloak-development.development.languages.akelius.com",
    testing:
      "https://business-school-keycloak-testing.development.languages.akelius.com",
    production:
      "https://business-school-keycloak.production.languages.akelius.com",
  },
  {
    type: "SP",
    name: "Build Box",
    link: true,
    git: "https://github.com/Akelius-Languages-Online/android-build-box/commit/",
    development: "https://android-app-box.development.languages.akelius.com",
  },
  {
    type: "SP",
    name: "RabbitMq",
    link: true,
    development:
      "https://business-school-rabbitmq-development.development.languages.akelius.com",
    testing:
      "https://business-school-rabbitmq-testing.development.languages.akelius.com",
    production:
      "https://business-school-rabbitmq-production.production.languages.akelius.com",
  },
];

export { services };
